import { render, staticRenderFns } from "./textCover.vue?vue&type=template&id=c62d2d28&"
import script from "./textCover.vue?vue&type=script&lang=ts&"
export * from "./textCover.vue?vue&type=script&lang=ts&"
import style0 from "./textCover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports